import * as Checkbox from '@radix-ui/react-checkbox'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import { CaretDownIcon } from '../icons/CaretDownIcon'
import { CheckmarkIcon } from '../icons/CheckmarkIcon'
import { REGION_OPTIONS } from './config'

interface IBranchSelectProps {
  onSelectRegions: (regions: string[]) => void
}

export function BranchSelect({ onSelectRegions }: IBranchSelectProps) {
  const [labels, setLabels] = useState<string[]>([])
  const [selectedIds, setSelectedIds] = useState<string[]>([])
  const t = useTranslations('Home')
  const tRegions = useTranslations('Regions')

  const toggleValue = (value: string, id: string) => {
    const translatedValue = tRegions(value)
    setLabels((prev) =>
      prev.includes(translatedValue)
        ? prev.filter((v) => v !== translatedValue)
        : [...prev, translatedValue]
    )
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    )
  }

  useEffect(() => {
    onSelectRegions(selectedIds)
  }, [selectedIds, onSelectRegions])

  const options = REGION_OPTIONS.map((option) => ({
    label: option.label,
    value: option.id
  }))

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="rounded-main text-primary-500 flex w-full cursor-pointer items-center truncate bg-gray-50 px-4 py-2 text-left">
        <span className="w-full min-w-0 flex-1 truncate">
          {labels.length ? labels.join(', ') : t('branches.selectLabel')}
        </span>
        <CaretDownIcon size="20px" className="ml-2 flex-shrink-0" />
      </DropdownMenu.Trigger>

      <DropdownMenu.Content
        sideOffset={4}
        className="content rounded- w-[var(--radix-dropdown-menu-trigger-width)] bg-white p-2 shadow-md"
      >
        {options.map((option) => (
          <DropdownMenu.Item
            key={option.value}
            onSelect={(e) => e.preventDefault()}
            className="flex cursor-pointer items-center gap-2 rounded px-2 py-1 hover:bg-gray-50"
          >
            <Checkbox.Root
              id={option.value}
              checked={selectedIds.includes(option.value)}
              onCheckedChange={() => toggleValue(option.label, option.value)}
              className="data-[state=checked]:bg-positive-500 mr-2 flex h-5 w-5 items-center justify-center rounded border border-gray-100"
            >
              <Checkbox.Indicator>
                <CheckmarkIcon className="h-3 w-3 text-white" />
              </Checkbox.Indicator>
            </Checkbox.Root>
            <label
              htmlFor={option.value}
              className="text-primary-500 text-body-2 cursor-pointer"
            >
              {tRegions(option.label)}
            </label>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  )
}
